<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-xl-12 no-padding">
        <div class="row  block-style" style="margin-bottom:20px">
            <div class="col-xl-6">
                <div class="grid__item medium-up--three-sixths small--btn-margin">
                    <h2>ArcGIS, the industry's most powerful mapping and analytics software</h2>
                    <p>gistec, Esri official distributor in the UAE, offers up-to-date apps and software, top-notch services, and comprehensive training courses on ArcGIS.</p>
                    <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-top:25px">
                        <a href="https://store.gistec.com" target="_blank" style="height: 40px;  margin-right: 20px; background-color:#00A6B6; font-weight: inherit; color: white;" class="btn btn-default">Shop Now</a>
                    </div>
                </div>
            </div>
            <div class="col-xl-6">
                <div class="grid__item medium-up--three-sixths order-md-last order-first text-right small--text-center">
                    <img class="img-fluid lazyloaded" src="https://cdn.shopify.com/s/files/1/0476/9677/3279/files/arcgis-graphics.png?v=1604391222" alt="ArcGIS">
                </div>
            </div>



        </div>


        <div class="row  block-style">

            <div class="col-xl-12" style="margin-top:30px">
                <div style="text-align:left;"><h2>Trending now</h2></div>
                <div class="custom-content section-block">

                    <div class="section-block--padding grid__item one-whole align--top-middle">
                        <div class="grid__item-inner grid__item-inner--html">
                            <div class="rte">
                                <div class="row">
                                    <div style="margin-top:20px" class="col-xl-3 grid__item medium-up--one-fifth small--one-half text-center home-icon-box">
                                        <a>
                                            <div class="home-icon-wrapper">
                                                <img style="width: 100px; height:100px; margin-bottom: 20px;" class="home-icon lazyloaded" src="https://cdn.shopify.com/s/files/1/0476/9677/3279/files/development.svg?v=1601556837" alt="mobile and web development">
                                            </div>
                                            <p><span>Mobile and web development</span></p>
                                        </a>
                                    </div>
                                    <div style="margin-top:20px" class="col-xl-3  grid__item medium-up--one-fifth small--one-half text-center home-icon-box">
                                        <a>
                                            <div class="home-icon-wrapper">
                                                <img style="width: 100px; height: 100px; margin-bottom: 20px;" class="home-icon lazyloaded" src="https://cdn.shopify.com/s/files/1/0476/9677/3279/files/gis.svg?v=1601557332" alt="gis data processing">
                                            </div>
                                            <p><span>GIS data processing</span></p>
                                        </a>
                                    </div>
                                    <div style="margin-top:20px" class="col-xl-3  grid__item medium-up--one-fifth small--one-half text-center home-icon-box">
                                        <a>
                                            <div class="home-icon-wrapper">
                                                <img style="width: 100px; height: 100px; margin-bottom: 20px;" class="home-icon lazyloaded" src="https://cdn.shopify.com/s/files/1/0476/9677/3279/files/mapping.svg?v=1601558555" alt="mapping and visualization">
                                            </div>
                                            <p><span>Mapping and visualization</span></p>
                                        </a>
                                    </div>
                                    <div style="margin-top:20px" class="col-xl-3 grid__item medium-up--one-fifth small--one-half text-center home-icon-box">
                                        <a>
                                            <div class="home-icon-wrapper">
                                                <img style="width: 100px; height: 100px; margin-bottom: 20px;" class="home-icon lazyloaded" src="https://cdn.shopify.com/s/files/1/0476/9677/3279/files/imagery.svg?v=1601558997" alt="imagery and remote sensing">
                                            </div>
                                            <p><span>Imagery and remote sensing</span></p>
                                        </a>
                                    </div>
                                    <div style="margin-top:20px" class="col-xl-3  grid__item medium-up--one-fifth small--one-half text-center home-icon-box">
                                        <a>
                                            <div class="home-icon-wrapper">
                                                <img style="width: 100px; height: 100px; margin-bottom: 20px;" class="home-icon lazyloaded" src="https://cdn.shopify.com/s/files/1/0476/9677/3279/files/configuration.svg?v=1601559164" alt="arcgis solutions configuration">
                                            </div>
                                            <p><span>ArcGIS solutions configuration</span></p>
                                        </a>
                                    </div>
                                    <div style="margin-top:20px" class="col-xl-3  grid__item medium-up--one-fifth small--one-half text-center home-icon-box">
                                        <a>
                                            <div class="home-icon-wrapper">
                                                <img style="width: 100px; height: 100px; margin-bottom: 20px;" class="home-icon lazyloaded" src="https://cdn.shopify.com/s/files/1/0476/9677/3279/files/design.svg?v=1601791382" alt="system design">
                                            </div>
                                            <p><span>System design</span></p>
                                        </a>
                                    </div>
                                    <div style="margin-top:20px" class="col-xl-3  grid__item medium-up--one-fifth small--one-half text-center home-icon-box">
                                        <a>
                                            <div class="home-icon-wrapper">
                                                <img style="width: 100px; height: 100px; margin-bottom: 20px;" class="home-icon lazyloaded" src="https://cdn.shopify.com/s/files/1/0476/9677/3279/files/share.svg?v=1601791596" alt="gis data visualization and sharing">
                                            </div>
                                            <p><span>GIS data visualization and sharing</span></p>
                                        </a>
                                    </div>
                                    <div style="margin-top:20px" class="col-xl-3  grid__item medium-up--one-fifth small--one-half text-center home-icon-box">
                                        <a>
                                            <div class="home-icon-wrapper">
                                                <img style="width: 100px; height: 100px; margin-bottom: 20px;" class="home-icon lazyloaded" src="https://cdn.shopify.com/s/files/1/0476/9677/3279/files/geodatabase.svg?v=1601791786" alt="enterprise geodatabase">
                                            </div>
                                            <p><span>Enterprise geodatabase</span></p>
                                        </a>
                                    </div>
                                    <div style="margin-top:20px" class="col-xl-3  grid__item medium-up--one-fifth small--one-half text-center home-icon-box">
                                        <a>
                                            <div class="home-icon-wrapper">
                                                <img style="width: 100px; height: 100px; margin-bottom: 20px;" class="home-icon lazyloaded" src="https://cdn.shopify.com/s/files/1/0476/9677/3279/files/cots.svg?v=1601791944" alt="third-party COTS installation and configuration">
                                            </div>
                                            <p><span>Third-party COTS installation and configuration</span></p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>


    </div>
</div>




